"use client"

import { PrintDataFields } from '@repo/types';
import { InventoryService } from '@repo/ui/lib/api/services/inventory.service';
import { useQueries } from '@tanstack/react-query';
import { printDataQueryKey } from './use-print-data';

/**
 * Hook pour fetcher les données d'impression de plusieurs inventaires en parallèle
 * Retourne les données formatées prêtes pour la génération PDF (labels résolus, formatés)
 */
export function useMultiPrintData(ids: number[]) {
  const inventoryService = new InventoryService();

  // Handle empty array case
  const validIds = ids.filter(id => !!id);

  const results = useQueries({
    queries: validIds.length > 0 
      ? validIds.map(id => ({
          queryKey: printDataQueryKey(id),
          queryFn: () => inventoryService.getPrintData(id),
          enabled: !!id,
          staleTime: 0,
          gcTime: 0,
        }))
      : [],
  });

  // Agréger les résultats
  const isLoading = validIds.length > 0 && results.some(r => r.isLoading);
  const hasError = results.some(r => r.error);
  const printDataList = results.map(r => r.data).filter((d): d is PrintDataFields => !!d);
  const errors = results.map((r, index) => ({ index, error: r.error })).filter(({ error }) => !!error);

  return { 
    printDataList, 
    isLoading, 
    hasError, 
    errors,
    results 
  };
}
